import { render, staticRenderFns } from "./ownerprofile.vue?vue&type=template&id=6dfffb47&scoped=true&"
import script from "./ownerprofile.vue?vue&type=script&lang=js&"
export * from "./ownerprofile.vue?vue&type=script&lang=js&"
import style0 from "./ownerprofile.vue?vue&type=style&index=0&id=6dfffb47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfffb47",
  null
  
)

export default component.exports